import "./index.css";
import { Form, Input } from "antd";
import EditModal from "../ui/EditModal";
import React, { useState } from "react";

import type { TypeProfileInfo } from "BlueratePersonalSite/interface";

const REQUIRED = [{ required: true, message: "inputs must not be empty" }];

type TypeFaqInfo = TypeProfileInfo.DTO["LandingPageSetUp"]["faqInfo"];

interface TypeEditFAQsProps<T = TypeFaqInfo> {
  value?: T;
  onChange?(value: T): void;
}

/**
 * @name EditFAQs 编辑常见问题
 */
const EditFAQs: React.FC<TypeEditFAQsProps> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  const [form] = Form.useForm<{ faqInfo: TypeFaqInfo }>();

  /**
   * @name onSubmit “Save”
   * @description 表单验证符合规则的提交
   */
  async function onSubmit() {
    const values = await form.validateFields();
    onChange?.(values.faqInfo);
    onOpen();
  }

  function onInsert() {
    const faqInfo = form.getFieldValue(["faqInfo"]);
    faqInfo.push({});
    form.setFieldValue("faqInfo", faqInfo);
  }

  function onOpen() {
    setOpen((b) => !b);
    if (open) {
      form.resetFields();
    } else {
      const faqInfo = value?.length ? value : [{}];
      form.setFieldsValue({ faqInfo });
    }
  }

  return (
    <>
      <img onClick={onOpen} src="/images/document-edit.svg" />
      <EditModal
        open={open}
        width={650}
        onOk={onSubmit}
        title="Edit FAQs"
        onCancel={onOpen}
        onInsert={onInsert}
        description={`In this section, you have the option to display common questions asked by borrowers.`}
      >
        <Form form={form} layout="vertical">
          <Form.List initialValue={[{}]} name="faqInfo">
            {(fields, { remove }) =>
              fields.map((v) => (
                <EditModal.Item
                  key={v.key}
                  title={`FAQ (${v.name + 1})`}
                  onDelete={() => remove(v.name)}
                >
                  <Form.Item
                    rules={REQUIRED}
                    label="Question"
                    name={[v.name, "label"]}
                  >
                    <Input placeholder="Please enter question" allowClear />
                  </Form.Item>

                  <Form.Item
                    label="Answer"
                    rules={REQUIRED}
                    name={[v.name, "children"]}
                  >
                    <Input.TextArea
                      rows={3}
                      allowClear
                      placeholder="Please enter Answer"
                    />
                  </Form.Item>
                </EditModal.Item>
              ))
            }
          </Form.List>
        </Form>
      </EditModal>
    </>
  );
};

export default EditFAQs;
